<template>
  <div class="ts-capture_content_container ts-signup-portal">
    <header>
      <h4>Your {{ $t("uorganization") }}</h4>
    </header>

    <el-form @submit.native.prevent>
      <p>
        How many employees does your {{ $t("lorganization") }} have in total?
      </p>
      <el-form-item
        :error="retrieveFieldError(modelState, 'totalEmployees.totalEmployeeCount')"
        :required="true"
      >
        <el-input
          placeholder
          type="number"
          v-model="currentRegistration.totalEmployees.totalEmployeeCount"
        >
        </el-input>
      </el-form-item>

      <div class="form-actions">
        <button
          v-on:click="storeSection()"
          class="ts-btn ts-btn-rounded ts-btn-white"
        >
          Back
        </button>
        <button
          v-on:click="storeSection()"
          class="ts-btn ts-btn-rounded ts-btn-secondary"
        >
          Next
        </button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  created() {
    if (this.currentRegistration.totalEmployees == null) {
      this.currentRegistration.totalEmployees = {};
    }
  },
  data() {
    return {
      modelState: {},
    };
  },
  computed: {
    currentRegistration() {
      return this.$store.state.registration.current_registration;
    },
  },
  methods: {
    storeSection() {
      this.isLoading = true;

      this.$store
        .dispatch("registration/store", this.currentRegistration)
        .then(() => {
          this.$router.app.$emit("navigateToNextStep");
        })
        .catch((res) => {
          this.modelState = res.errors;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
